module.exports = __webpack_public_path__ + "static/media/11.Play Time 5.cf5909fe.gif";